import { IconChevDown } from './icons'
import Button from './Button'
import React from 'react'

interface Props {
  onClick: () => void
  expanded: boolean
}

const ExpandToggle: React.FC<Props> = ({ onClick, expanded }) => {
  return (
    <Button
      round
      onClick={onClick}
    >
      <img
        src={IconChevDown}
        alt={expanded ? 'open' : 'closed'}
        style={{
          transition: '200ms',
          transform: `rotate(${expanded ? -0.5 : 0}turn)`
        }}
      />
    </Button>
  )
}

export default ExpandToggle
